const mutationType = {
  SET_CATALOG_LIST: 'setCatalogList',
  SET_SET_BRAND_LIST: 'setBrandList',
  SET_LANDING_PAGES_LIST: 'setLandingPagesList',
};

const actionType = {
  SET_CATALOG_LIST: 'setCatalogList',
  SET_SET_BRAND_LIST: 'setBrandList',
  SET_LANDING_PAGES_LIST: 'setLandingPagesList',
};

export const state = () => ({
  catalogList: [],
  brandsList: [],
  landingPagesList: [],
});

export const mutations = {
  [mutationType.SET_CATALOG_LIST]: (state, catalogList) => {
    state.catalogList = catalogList;
  },
  [mutationType.SET_SET_BRAND_LIST]: (state, brandsList) => {
    state.brandsList = brandsList;
  },
  [mutationType.SET_LANDING_PAGES_LIST]: (state, landingsList) => {
    state.landingPagesList = landingsList;
  },
};

export const actions = {
  [actionType.SET_CATALOG_LIST]: async function ({ commit }) {
    try {
      const res = await this.$api.agent.transport
        .get('categories?fields=name,id,url&filter[depth]=1&per-page=9999')
        .then((res) => res.data);

      if (res.length) {
        commit(mutationType.SET_CATALOG_LIST, res);
      }
      return res;
    } catch (e) {
      console.error('error ', e);
      return [];
    }
  },

  [actionType.SET_SET_BRAND_LIST]: async function ({ commit }) {
    try {
      const res = await this.$api.agent.transport
        .get('brands?fields=name,id,url&per-page=9999')
        .then((res) => res.data);
      if (res.length) {
        commit(mutationType.SET_SET_BRAND_LIST, res);
      }
      return res;
    } catch (e) {
      console.error('error ', e);
      return [];
    }
  },

  [actionType.SET_LANDING_PAGES_LIST]: async function ({ commit }) {
    try {
      const res = await this.$api.agent.transport.get('filter-pages?fields=title,id,url&per-page=9999')
        .then((res) => res.data);
      if (res.length) {
        commit(mutationType.SET_LANDING_PAGES_LIST, res);
      }
      return res;
    } catch (e) {
      console.error('error ', e);
      return [];
    }
  },
};
export const getters = {
  isListsLoaded: ({ catalogList, brandsList, landingPagesList }) => Boolean(
    catalogList.length
            && brandsList.length
            && landingPagesList.length,
  ),
  catalogList: ({ catalogList }) => catalogList,
  brandsList: ({ brandsList }) => brandsList,
  landingPagesList: ({ landingPagesList }) => landingPagesList,
};
